import { render } from "./news-category.vue?vue&type=template&id=dbb4477e&scoped=true"
import script from "./news-category.vue?vue&type=script&lang=js"
export * from "./news-category.vue?vue&type=script&lang=js"

import "./news-category.vue?vue&type=style&index=0&id=dbb4477e&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb4477e"]])

export default __exports__